/* eslint-disable no-console */
import { router } from '@/main.js';

function getLocalhost() {
    const curWwwPath = window.document.location.href;
    const pathName = window.document.location.pathname;
    const pos = curWwwPath.indexOf(pathName);
    return curWwwPath.substring(0, pos);
}

const site = process.env.NODE_ENV === "development" ?
    'http://localhost:8000/api/' : getLocalhost() + '/course/api/';
// const site = 'http://localhost:8000/api/'

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

// get method
async function asyncFetchGet(route, params = '') {
    try {
        let url = '';
        if (params !== '')
            url = `${site}${route}${params}`;
        else
            url = `${site}${route}/`;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + localStorage.getItem('token')
            }
        });
        if (response.status === 401) {
            localStorage.removeItem('token');
            router.push('/login');
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
    }
}
// post method
async function asyncFetchPost(route, body) {
    try {
        const response = await fetch(`${site}${route}/`, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + localStorage.getItem('token')
            }
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
    }
}

// put method
async function asyncFetchPatch(route, id, body) {
    try {
        const response = await fetch(`${site}${route}/${id}/`, {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + localStorage.getItem('token')
            }
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
    }
}

async function asyncFetchDelete(route, id) {
    try {
        const response = await fetch(`${site}${route}/${id}/`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('token')
            }
        });
        if (response.status === 204) {
            return 'succeed'
        }
        return 'failed';
    } catch (error) {
        console.log(error);
    }
}

async function asyncFetchFile(route, body) {
    try {
        const response = await fetch(`${site}${route}/`, {
            mode: 'cors',
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/octet-stream',
            }
        });
        return response;
    } catch (error) {
        console.log(error);
    }
}

export { site, asyncFetchGet, asyncFetchPatch, asyncFetchPost, asyncFetchDelete, asyncFetchFile, getCookie }